import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBox,
  faBoxes,
  faBoxOpen,
  faBug,
  faCalendar,
  faCamera,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronLeft,
  faClipboardList,
  faClock,
  faCloudUploadAlt,
  faComment,
  faDownload,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileImage,
  faFilePdf,
  faFileWord,
  faGripHorizontal,
  faHeart,
  faHistory,
  faImage,
  faImages,
  faInbox,
  faInfoCircle,
  faKey,
  faLink,
  faList,
  faLock,
  faMapMarkerAlt,
  faMinus,
  faMobileAlt,
  faNewspaper,
  faPaperPlane,
  faPen,
  faPlus,
  faSave,
  faShare,
  faShoppingCart,
  faSpinner,
  faSquare,
  faStickyNote,
  faTable,
  faTimes,
  faTimesCircle,
  faTrash,
  faUndoAlt,
  faUnlink,
  faUser,
  faUsers,
  faCircle as fasCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faDotCircle,
  faCircle as farCircle,
} from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { smbIdTag } from "@/plugins/icons/smbIdTag";

library.add(faEye);
library.add(faEyeSlash);
library.add(faMobileAlt);
library.add(faList);
library.add(faKey);
library.add(faCheckCircle);
library.add(faSquare);
library.add(faHeart);
library.add(faTimesCircle);
library.add(faUser);
library.add(faTimes);
library.add(faBell);
library.add(faBars);
library.add(fasCircle);
library.add(faNewspaper);
library.add(faPen);
library.add(faCamera);
library.add(faBug);
library.add(faUsers);
library.add(faShoppingCart);
library.add(faEdit);
library.add(faStickyNote);
library.add(faExchangeAlt);
library.add(faEnvelope);
library.add(faChartLine);
library.add(faPlus);
library.add(faMinus);
library.add(faHistory);
library.add(faLink);
library.add(faUnlink);
library.add(smbIdTag);
library.add(farCircle);
library.add(faDotCircle);
library.add(faMapMarkerAlt);
library.add(faLock);
library.add(faShare);
library.add(faTrash);
library.add(faTable);
library.add(faGripHorizontal);
library.add(faUndoAlt);
library.add(faExclamationTriangle);
library.add(faDownload);
library.add(faFileImage);
library.add(faFilePdf);
library.add(faFileWord);
library.add(faFile);
library.add(faSpinner);
library.add(faCloudUploadAlt);
library.add(faChevronLeft);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faBox);
library.add(faBoxes);
library.add(faBoxOpen);
library.add(faCalendar);
library.add(faCheck);
library.add(faCheckDouble);
library.add(faClipboardList);
library.add(faClock);
library.add(faComment);
library.add(faExclamationCircle);
library.add(faImage);
library.add(faImages);
library.add(faInbox);
library.add(faInfoCircle);
library.add(faPaperPlane);
library.add(faSave);

Vue.component("FaIcon", FontAwesomeIcon);
